/**
 * Adapter for 'drawers'.
 *
 * @module app/components/DrawersAdapter
 */
import BetSlipAdapter from './BetSlipAdapter';
import DeviceDetector from './DeviceDetector';
import jQuery from 'jquery';
import MessageBusTopics from '../../common/MessageBusTopics';

/**
 * string for the class that is used to define active
 *
 * @type {String}
 */
var activeState = '-active';

/**
 * last drawer that we had (used so we can change the icon back!)
 *
 * @type {Object} drawer
 */
var lastDrawer = null;

/**
 * string for the id that is active for a drawer with multiple ids
 *
 * @type {string|null}
 */
var activeId = null;
/*jshint -W079 */
let scrollTo = 0;
var firstLoad = true;

/**
 * drawers object that defines all the drawers that used
 *  this is essentially config
 *
 * @type {Object}
 */
var drawers = {
    'betslip': {
        'target': '.toggle-betslip',
        'direction': 'right',
        'id': '#betSlip',
        'icon': 'icon-bet-slip',
        'betSlipMode': {
            'arg1': 'B',
            'arg2': 'GoBets',
        },
        'setTab': 'betslip',
        'topic': MessageBusTopics.BETSLIP_SHOW_BETSLIP_TAB,
    },
    'openBets': {
        'target': '.toggle-openbet',
        'direction': 'right',
        'id': '#slipopenBets',
        'icon': 'icon-openBets',
        'betSlipMode': {
            'arg1': 'V',
            'arg2': 'GoOpenBets',
        },
        'setTab': 'openbets',
        'topic': MessageBusTopics.BETSLIP_SHOW_OPENBETS_TAB,
    },
    'tipAdvisor': {
        'target': '#toggle-tipadvisor',
        'direction': 'right',
        'id': '#slipTipit',
        'icon': 'icon-tip-advisor',
        'betSlipMode': {
            'arg1': 'TA',
            'arg2': 'GoCommunitySlip',
        },
        'setTab': 'tipadvisor',
        'topic': false,
    },
};

/**
 * @param   {String} direction   empty string for closing panel, else a direction
 *
 * @returns {void}
 *
 * @private
 */
var setPanelOpenDirection = function (direction) {

    jQuery('body').attr('data-panel-open', direction);
};

/**
 * method to find get the active drawer direction
 *
 * @returns {string}
 *
 * @private
 */
var getPanelOpenDirection = function () {

    return jQuery('body').attr('data-panel-open');
};

/**
 * method to hide/'undisplay' an id
 *
 * @param {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var hideId = function (drawer) {

    setLinkInactive(drawer);
    if (drawer.id !== false) {
        jQuery(drawer.id).addClass('displayNone');
    }
};

/**
 * method to set an id as displayed
 *
 * @param {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var displayId = function (drawer) {

    jQuery(drawer.id).removeClass('displayNone');
    setLinkActive(drawer);
    activeId = drawer.id;

    //if statement to check if we need to add a displayNone to the previous id
    if (lastDrawer !== null && !jQuery(lastDrawer.id).hasClass('displayNone')) {
        jQuery(lastDrawer.id).addClass('displayNone');
    }
};

/**
 * method to check if the quick deposit slip exists
 *
 * @returns {Boolean}
 *
 * @private
 */
var quickDepositExists = function () {

    //is the slipQuickDeposit present without a displayNone class ?
    return jQuery('#slipQuickDeposit').not('.displayNone').length > 0;
};

/**
 * method to check if a bet receipt exist or a pre receipt loading screen
 *
 * @returns {Boolean}
 *
 * @private
 */
var betConfirmationExists = function () {

    // #slipReceiptBox - receipt, #slipBetDelay - loading screen before receipt appears
    return jQuery('#slipReceiptBox, #slipBetDelay').not('.displayNone').length > 0;
};

/**
 * method to stop
 *
 * @param   {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var changeBetSlipMode = function (drawer) {

    window.WH.messageBus.publishSticky(MessageBusTopics.BETSLIP_TAB_SET, drawer.setTab);
};

/**
 * method to change the id that is active
 *
 * @param   {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var changeActiveId = function (drawer) {

    if (lastDrawer !== null) {
        hideId(lastDrawer);
        setLinkInactive(lastDrawer);
    }

    displayId(drawer);
    changeBetSlipMode(drawer);
};

/**
 * method to open a drawer (closes previously opened other drawers)
 *
 * @param   {Object} drawer
 *
 * @returns  {void}
 *
 * @private
 */
var openDrawer = function (drawer) {

    openDrawersOffCanvas(drawer);
    setPanelOpenDirection(drawer.direction);

    if (drawer.id !== false) {
        changeActiveId(drawer);
    }

};

/**
 * method to close all the drawers
 *
 * @returns {void}
 *
 * @private
 */
var closeDrawers = function () {
    // remove the query string parameter for Android Native
    if (DeviceDetector.isNativeAndroid()) {
        if ((location.hash === '#betslip') || (location.hash === '#openbets')) {
            location.hash = '';
        }
        window.removeEventListener('popstate', closeDrawers);
    }

    var mainOffCanvas = jQuery('#main-off-canvas');
    mainOffCanvas.removeClass('off-canvas--move-left');
    closeDrawersOffCanvas();

    setPanelOpenDirection('');
    resetDrawers();
};

/**
 * Opens betslip drawer
 *
 * @returns {void}
 *
 * @private
 */
var openBetslipDrawer = function () {
    var newBetslip = window.whStatic.config.spitfireBetslip || false;

    if (newBetslip) {
        return;
    }

    openDrawer(drawers.betslip);
};

/**
 * Opens Open Bets drawer
 *
 * @returns {void}
 *
 * @private
 */
var openOpenBetsDrawer = function () {
    var newBetslip = window.whStatic.config.spitfireBetslip || false;

    if (newBetslip) {
        return;
    }

    openDrawer(drawers.openBets);
};

/**
 * Opens Tip Advisor drawer
 *
 * @returns {void}
 *
 * @private
 */
var openTipAdvisorDrawer = function () {

    openDrawer(drawers.tipAdvisor);
};

/**
 * method to reset a drawer
 *
 * @param   {Object} drawer
 *
 * @returns  {void}
 *
 * @private
 */
var resetDrawer = function (drawer) {

    jQuery(drawers[drawer].target).children('i').removeClass('icon-x');
    jQuery(drawers[drawer].target).children('i').addClass(drawers[drawer].icon);
    jQuery(drawers[drawer].target).removeClass(activeState);
    jQuery(drawers[drawer].id).addClass('displayNone');
};

/**
 * method to reset the drawers back to their original state
 *
 * @returns {void}
 *
 * @private
 */
var resetDrawers = function () {

    jQuery.each(drawers, resetDrawer);
    lastDrawer = null;
};

/**
 * method to put the original icon back on the last drawer
 *
 * @returns {void}
 *
 * @private
 */
var checkIfLastDrawerLinkNeedsRestoring = function () {

    if (lastDrawer !== null) {
        var lastButton = jQuery(lastDrawer.target);
        lastButton.children('i').removeClass('icon-x');
        lastButton.children('i').addClass(lastDrawer.icon);
        setLinkInactive(lastDrawer);
    }
};

/**
 * method to set a drawer's link as active
 *
 * @param   {Object} drawer
 *
 * @returns  {void}
 *
 * @private
 */
var setLinkActive = function (drawer) {

    var button = jQuery(drawer.target);

    button.addClass(activeState);

    button.children('i').removeClass(drawer.icon);
    button.children('i').addClass('icon-x');

    checkIfLastDrawerLinkNeedsRestoring();
};

/**
 * method to set a drawer's link as inactive
 *
 * @param   {Object} drawer
 *
 * @returns  {void}
 *
 * @private
 */
var setLinkInactive = function (drawer) {

    var button = jQuery(drawer.target);

    button.removeClass(activeState);
};

/**
 * method to check if this target (button) has an active state
 *
 * @param   {Object} drawer
 *
 * @returns {Boolean}
 *
 * @private
 */
var isTargetActive = function (drawer) {

    return jQuery(drawer.target).hasClass(activeState);
};

/**
 * method to toggle a draw between open and closed
 *
 * @param {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var toggleDrawer = function (drawer) {

    if (isTargetActive(drawer)) {
        closeDrawers();
    } else {
        openDrawer(drawer);
    }
};

/**
 * method to set lastDrawer, sets as null if drawer is closing
 *
 * @param {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var setLastDrawer = function (drawer) {

    if (getPanelOpenDirection() === '') {
        lastDrawer = null;
    } else {
        lastDrawer = drawer;
    }
};

/**
 * action for opening a drawer. also works out if we don't actually need to open a drawer
 *   and just change the displayed id
 *
 * @param {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var drawerAction = function (drawer) {

    //check if we are actually changing drawer or just ids and is not the current drawer
    if (getPanelOpenDirection() === drawer.direction && (drawer !== lastDrawer)) {
        //just change ids
        changeActiveId(drawer);
    } else {
        //toggle the drawer
        toggleDrawer(drawer);
    }

    setLastDrawer(drawer);
};

/**
 * action to bind to a drawer button/link
 *  opens/closes the drawer and toggles it's active class
 *
 * @param   {Object} event
 *
 * @returns {Boolean} false - to disable default action
 *
 * @private
 */
var clickAction = function (event) {

    var drawer = event.data;
    drawerAction(drawer);
    return false;
};

/**
 * method to bind an event to the event action with it's parameters
 *
 * @param   {Object} drawer
 *
 * @returns {void}
 *
 * @private
 */
var bindClick = function (drawer) {

    jQuery(drawer.target).bind('click', drawer, clickAction);
};

/**
 * method to bind clicks for opening and closing drawers
 *
 * @returns {void}
 *
 * @private
 */
var bindClicks = function () {

    //bind betslip drawer
    bindClick(drawers.betslip);
    //bind open bets
    bindClick(drawers.openBets);
    //bind tip advisor
    bindClick(drawers.tipAdvisor);
    // close betslip
    jQuery('#close-betslip, .toolbar-button--close, #betslip-overlay').off('click.closeBetslip')
        .on('click.closeBetslip', function () {
            closeDrawers();
            BetSlipAdapter.updateSidebarsPosition('close');
            window.WH.messageBus.publish(MessageBusTopics.BETSLIP_CLOSE_DRAWERS, true);
        });
    jQuery('#open-betslip').on('click', BetSlipAdapter.reloadBetslip);
};

/**
 * Check if the drawer should be pre-opened on page load
 *
 * @returns {Boolean}
 *
 * @private
 */
var checkIfShouldBePreOpened = function () {

    //does the quick deposit or bet confirmation markup exist?
    return (quickDepositExists() || betConfirmationExists());
};

/**
 * Subscribes to events coming from betslip.
 *
 * @returns {void}
 *
 * @private
 */
var subscribeBetslipEvents = function () {

    window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_OPEN_BETSLIP_DRAWER, openBetslipDrawer);
    window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_OPEN_OPEN_BETS_DRAWER, openOpenBetsDrawer);
    window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_OPEN_TIP_ADVISOR_DRAWER, openTipAdvisorDrawer);
    window.WH.messageBus.subscribe(MessageBusTopics.BETSLIP_CLOSE_DRAWERS, closeDrawers);
};

/**
 * openDrawersIOS
 */
var openDrawersOffCanvas = function (drawer) {

    window.WH.messageBus.publish(MessageBusTopics.BETSLIP_OPENING);
    if (drawer.topic) {
        window.WH.messageBus.publish(drawer.topic);
    }

    if (DeviceDetector.isNativeAndroid()) {
        setTimeout(() => {
            window.addEventListener('popstate', closeDrawers);
        }, 100);
    }

    var mainOffCanvas = jQuery('#main-off-canvas');
    //var isIOS = /iPad|iPhone|iPod/.test(navigator.platform);

    // Add location.hash for Android Native
    // so that the back button closes the bet slip, not the whole app
    if (DeviceDetector.isNativeAndroid()) {
        const tab = drawer.setTab;
        location.hash = tab;
    }
    mainOffCanvas.addClass('off-canvas--move-left');

    // TODO: Use DeviceDetector
    if (!DeviceDetector.isIOS()) {

        mainOffCanvas.addClass('off-canvas--right-position-fixed');
    } else {

        openDrawersOffCanvasIOS(mainOffCanvas);
    }
};

/**
 * closeDrawersIOS
 */
var closeDrawersOffCanvas = function () {

    var mainOffCanvas = jQuery('#main-off-canvas');
    //var isIOS = /iPad|iPhone|iPod/.test(navigator.platform);

    if (!DeviceDetector.isIOS()) {

        mainOffCanvas.removeClass('off-canvas--right-position-fixed');
    } else {

        closeDrawersOffCanvasIOS(mainOffCanvas);
    }
};

/**
 * openDrawersOffCanvas for IOS
 */
var openDrawersOffCanvasIOS = function (mainOffCanvas) {

    setContainerScrollable(mainOffCanvas.find('.off-canvas__main'));

    if (firstLoad && jQuery(window).width() >= 1024) {

        openDrawersOffCanvasIOSTabletLandscape(mainOffCanvas);
    } else {

        scrollTo = jQuery(window).scrollTop();
        jQuery(window).scrollTop(0);
    }

    openDrawersOffCanvasIOSOrientation(mainOffCanvas);
};

/**
 * openDrawersOffCanvasIOSTabletLandscape
 * @param mainOffCanvas
 */
var openDrawersOffCanvasIOSTabletLandscape = function (mainOffCanvas) {

    mainOffCanvas.addClass('off-canvas--right-position-fixed');
    setTimeout(function () {
        mainOffCanvas.removeClass('off-canvas--right-position-fixed');
    }, 0);
    firstLoad = false;

    setContainerScrollable(mainOffCanvas.find('.off-canvas__right'));
};

/**
 * setContainerScrollable
 * @param element
 */
var setContainerScrollable = function (element) {

    element.css({
        'height': jQuery(window).height(),
        'overflow': 'hidden',
        'overflow-y': 'scroll',
    });
};

/**
 * openDrawersOffCanvasIOSOrientation
 */
var openDrawersOffCanvasIOSOrientation = function (mainOffCanvas) {

    // TODO: see the support of addEventListener and orientationchange
    //       Remove when close
    window.addEventListener('orientationchange', function () {
        mainOffCanvas.find('.off-canvas__main').css({
            'height': jQuery(window).height(),
        });

        if (jQuery(window).width() >= 1024) {

            openDrawersOffCanvasIOSOrientationLandscape(mainOffCanvas);
        } else {

            mainOffCanvas.find('.off-canvas__right').css({
                'height': 'auto',
            });
        }
    }, false);
};

var openDrawersOffCanvasIOSOrientationLandscape = function (mainOffCanvas) {

    mainOffCanvas.addClass('off-canvas--right-position-fixed');

    setTimeout(function () {
        mainOffCanvas.removeClass('off-canvas--right-position-fixed');
    }, 0);
};

/**
 * closeDrawersOffCanvas
 */
var closeDrawersOffCanvasIOS = function (mainOffCanvas) {

    mainOffCanvas.find('.off-canvas__main').css({
        'height': 'auto',
    });
    mainOffCanvas.find('.off-canvas__right').css({
        'height': 'auto',
    });

    if (jQuery(window).width() < 1024) {

        jQuery(window).scrollTop(scrollTo);
    }
};

/**
 * api var for methods included in this module's return statement
 *
 * @type {Object}
 */
var api = {

    module: {
        changeBetSlipMode: changeBetSlipMode,
    },

    /**
     * init method
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        bindClicks();
        resetDrawers();
        subscribeBetslipEvents();

        if (checkIfShouldBePreOpened()) {
            openDrawer(drawers.betslip);
        }
        /**
         * method to close the betSlip
         *
         * @returns {void}
         *
         * @public
         */

    },

    closeBetSlip: function () {

        closeDrawers();    },

    /**
     * method to open the betSlip
     *
     * @returns {void}
     *
     * @public
     */
    openBetSlip: function () {

        openDrawer(drawers.betslip);
    },
};

export default api;
